import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Shield, Zap, DollarSign } from "lucide-react";

const CTASection = () => {
  return (
    <section className="py-20">
      <div className="container mx-auto px-4 md:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="rounded-3xl gradient-hero p-10 md:p-16 relative overflow-hidden"
        >
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-10 left-10 w-40 h-40 rounded-full bg-accent blur-3xl" />
            <div className="absolute bottom-10 right-10 w-60 h-60 rounded-full bg-white blur-3xl" />
          </div>

          <div className="relative z-10 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
            <div>
              <h2 className="text-3xl md:text-5xl font-display font-bold text-white mb-4 leading-tight">
                Deixe a IA encontrar
                <br />
                a permuta ideal.
              </h2>
              <p className="text-lg text-white/70 font-body max-w-md mb-8">
                Cadastre-se gratuitamente e deixe nosso algoritmo inteligente encontrar matches perfeitos para o seu imóvel. Sem taxa de cadastro, com negociação assistida.
              </p>
              <Link to="/signup">
                <Button variant="accent" size="xl">
                  Começar agora — é grátis
                </Button>
              </Link>
            </div>

            <div className="space-y-4">
              {[
                { icon: Shield, text: "Dados protegidos até o interesse mútuo" },
                { icon: Zap, text: "Algoritmo de IA com score de compatibilidade automático" },
                { icon: DollarSign, text: "Simulação financeira integrada à negociação" },
              ].map((item) => (
                <div key={item.text} className="flex items-center gap-3 bg-white/10 backdrop-blur-sm rounded-xl px-5 py-4">
                  <item.icon className="text-accent shrink-0" size={22} />
                  <span className="text-white font-body text-sm">{item.text}</span>
                </div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
